import React, { FunctionComponent, useEffect, useRef } from 'react';
import WaveSurfer from 'wavesurfer.js';

interface Props {
  url: string;
  waveColor?: string;
}

const BasicWaveform: FunctionComponent<Props> = ({ url, waveColor }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const wavesurfer = WaveSurfer.create({
        container: containerRef.current,
        waveColor: waveColor || 'rgb(200, 0, 200)',
        progressColor: 'rgb(100, 0, 100)',
        url: url,
        interact: false,
        autoplay: false,
        hideScrollbar: true,
        autoCenter: true,
        height: 20, // Explicitly set height
        normalize: true, // Normalize the waveform
      });

      wavesurfer.on('error', (err) => {
        console.error('WaveSurfer error:', err);
      });
    }
  }, [url]);

  return (
    <div ref={containerRef} style={{ width: '100%', height: '100%' }}></div>
  );
};

export default BasicWaveform;
